<template>
    <div class="journalbox">
        <div class="title">樓盤編號：{{$route.query.propertyId}}</div>
        <div class="tablebox">
            <div class="tablecon">
            <!-- :header-cell-style="{ background: 'rgba(80,181,255,0.15)', color: '#444' }" -->
            <el-table ref="tableJournal" :header-cell-style="headStyle" :data="getTableData[0]" style="width: 100%" fit highlight-current-row class="table-fixed">
                <template v-for="(item, index) in getTableData[1]">
                    <!-- :min-width="item.minWidth || 80" -->
                    <el-table-column :fixed="index== 0 && getTableData[1].length>2" :render-header="renderheader" :key="index" :label="item.unit ? `${item.label}(${item.unit})` : item.label" :prop="item.value" :header-align="item.headerAlign || 'left'"   :min-width="index == 0 ? 150 :175" >
                        <template slot-scope="scope">
                            <span :class="[scope.row.type0 != scope.row.type1 && index == 1 && item.value != 'mainIndex' &&  getTableData[1].length>2 ? 'red' : '', item.value == 'mainIndex' ? 'titblack' : '']">
                                <p class="overflow" v-if="(scope.row.mainIndex == '樓盤介紹(英)' || scope.row.mainIndex == '樓盤介紹(中)')" v-html="tableFormatter(item.value, scope.row)"></p>
                                <p v-else>
                                    {{ tableFormatter(item.value, scope.row) }}
                                </p>
                            </span>

                            <span class="blucopy" v-if="(scope.row.mainIndex == '樓盤介紹(英)' || scope.row.mainIndex == '樓盤介紹(中)') && item.value != 'mainIndex' && scope.row[item.value] " @click= "onCopy(scope.row[item.value])">{{scope.row.mainIndex == '樓盤介紹(中)'?'複製':'COPY'}}</span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>
        </div>
        <div class="left-right-scorll">
            <span onselectstart="return false">
                <svg @click="clicRightScroll('tablecon')" class="icon" aria-hidden="true">
                    <use xlink:href="#iconzuo" />
                </svg>
            </span>
            <span onselectstart="return false">
                <svg @click="clicLeftScroll('tablecon')" class="icon" aria-hidden="true">
                    <use xlink:href="#iconyou" />
                </svg>
            </span>
        </div>
    </div>
</template>

<script>
export default {
 data() {
  return {
    headerLists : [
                {
                    label: '使用者,修改時間',
                    value: 'createUser',
                    unit: '',
                    headerAlign: 'left',
                    Width: '80',
                    minWidth: '150',
                    align: 'center'
                },
                {
                    label: '樓盤類型/子類型',
                    value: 'propertyCategoryWithCulture',
                    unit: '',
                    headerAlign: 'left',
                    minWidth: '200',
                    align: 'left'
                },
                {
                    label: '物業編號',
                    value: 'propertyNo',
                    unit: '',
                    headerAlign: 'left',
                    minWidth: '200',
                    align: 'left'
                },
                {
                    label: '屋苑或大廈名稱',
                    value: 'estateNameWithCulture',
                    unit: '',
                    headerAlign: 'left',
                    minWidth: '200',
                    align: 'left'
                },
                {
                    label: '座數',
                    value: 'buildingNameWithCulture',
                    unit: '',
                    headerAlign: 'left',
                    minWidth: '200',
                    align: 'left'
                },
                {
                    label: '樓層',
                    value: 'unitFloorWithCulture',
                    unit: '',
                    headerAlign: 'left',
                    minWidth: '200',
                    align: 'left'
                },
                
                {
                    label: '單位',
                    value: 'roomNo',
                    unit: '',
                    headerAlign: 'left',
                    minWidth: '200',
                    align: 'left'
                },
                {
                    label: '樓盤資料顯示',
                    value: 'propertyShowWithCulture',
                    unit: '',
                    headerAlign: 'left',
                    minWidth: '200',
                    align: 'left'
                },
                {
                    label: '房間數目',
                    value: 'roomNumberWithCulture',
                    unit: '',
                    headerAlign: 'left',
                    minWidth: '200',
                    align: 'left'
                },
                {
                    label: '洗手間數目',
                    value: 'toiletNumberWithCulture',
                    unit: '',
                    headerAlign: 'left',
                    minWidth: '200',
                    align: 'left'
                },
                {
                    label: '放售價',
                    value: 'salePrice',
                    unit: '',
                    headerAlign: 'left',
                    minWidth: '200',
                    align: 'left'
                },
                {
                    label: '價錢(未補)',
                    value: 'unPaidSalePrice',
                    unit: '',
                    headerAlign: 'left',
                    minWidth: '200',
                    align: 'left'
                },
                {
                    label: '放租價',
                    value: 'rentPrice',
                    unit: '',
                    headerAlign: 'left',
                    minWidth: '200',
                    align: 'left'
                },
                {
                    label: '實用面積(呎)',
                    value: 'saleableArea',
                    unit: '',
                    headerAlign: 'left',
                    minWidth: '200',
                    align: 'left'
                },
                {
                    label: '建築面積(呎)',
                    value: 'buildingArea',
                    unit: '',
                    headerAlign: 'left',
                    minWidth: '200',
                    align: 'left'
                },
                {
                    label: '起租日(租盤)',
                    value: 'beginRentTimeString',
                    unit: '',
                    headerAlign: 'left',
                    minWidth: '200',
                    align: 'left'
                },
                {
                    label: '放盤標題(中)',
                    value: 'titleCN',
                    unit: '',
                    headerAlign: 'left',
                    minWidth: '200',
                    align: 'left'
                },
                {
                    label: '放盤標題(英)',
                    value: 'titleEN',
                    unit: '',
                    headerAlign: 'left',
                    minWidth: '200',
                    align: 'left'
                },
                {
                    label: '樓盤介紹(中)',
                    value: 'introduceCN',
                    unit: '',
                    headerAlign: 'left',
                    minWidth: '200',
                    align: 'left'
                },
                {
                    label: '樓盤介紹(英)',
                    value: 'introduceEN',
                    unit: '',
                    headerAlign: 'left',
                    minWidth: '200',
                    align: 'left'
                },
                {
                    label: '影片連結',
                    value: 'videoLinks',
                    unit: '',
                    headerAlign: 'left',
                    minWidth: '200',
                    align: 'left'
                },
                {
                    label: 'VR連結',
                    value: 'vrLinks',
                    unit: '',
                    headerAlign: 'left',
                    minWidth: '200',
                    align: 'left'
                },
                {
                    label: '代理人',
                    value: 'agentNames',
                    unit: '',
                    headerAlign: 'left',
                    minWidth: '200',
                    align: 'left'
                },
            ],
            tableDatas:[],
  }
 },
    computed:{
        getTableData() {
            return this.fotmatterTableData(this.tableDatas, this.headerLists);
        }
    },
    created(){
        this.getTableDatass()
    },
    methods:{
        headStyle({ row, column, rowIndex, columnIndex }){
            // 针对表头中'使用者'如有变动需标红
            if(columnIndex == 1 && row.length>=3 && row[1].label.split(",")[0] != row[2].label.split(",")[0]){
                return 'color: #E50113;background: rgba(80,181,255,0.15);font-weight:400'
            }else{
                return 'color: #444444;background: rgba(80,181,255,0.15);font-weight:400'
            }
        },
        onCopy(data) {
            navigator.clipboard.writeText(data).then(() => {
                this.$message.success('複製成功')
            })
        },
        clicLeftScroll(data) {
            let left = this.$(`.${data} .el-table__body-wrapper `).scrollLeft();
            this.$(`.${data} .el-table__body-wrapper`).animate({ scrollLeft: left + 200 }, 200);
        },
        clicRightScroll(data) {
            let left = this.$(`.${data} .el-table__body-wrapper `).scrollLeft();
            if (left >= 200) {
                this.$(`.${data} .el-table__body-wrapper `).animate({ scrollLeft: left - 200 }, 200);
            } else {
                this.$(`.${data} .el-table__body-wrapper `).animate({ scrollLeft: 0 }, 200);
            }
        },
        // 解决表头数据 需要为两行的换行问题
        renderheader(h,{column,$index}){
            return h("div",{},[
                h("div",{},column.label.split(",")[0]),
                // 针对表头'使用者'变红后,'修改时间'被同步变红问题,'修改时间'需要为黑色
                h("div",{style:{color:'#444'}},column.label.split(",")[1]),
            ])
        },
        getTableDatass() {
            if(this.$route.query.propertyId && this.$route.query.operationID){
                this.axios.get(this.pub.getApi().GetOperationUpdatePropertyInfo,{
                    params: {
                        operationID:this.$route.query.operationID,
                        propertyId:this.$route.query.propertyId
                    }
                }).then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        this.tableDatas = res.data.result;
                        // 解决固定列错位问题
                        this.$nextTick(() => {
                            if (this.$refs.tableJournal && this.$refs.tableJournal.doLayout) {
                                this.$refs.tableJournal.doLayout();
                            };
                        })
                    }
                });
            }
        },
        // 行列数据转化
    fotmatterTableData(data, header) {
      let enddata = [];
      let endheader = [];
      header.forEach((item, index) => {
        if (index === 0) {
          endheader.push({
            label: header[index].label,
            value: 'mainIndex',
            unit: header[index].unit,
            headerAlign: header[index].headerAlign,
            minWidth: header[index].minWidth,
            align: header[index].align
          });
          data.forEach((ele, idx) => {
            endheader.push({
              label: `${ele[header[index].value]},${ele.createTimeString}`,
              value: `type${idx}`,
            });
          });
        } else {
          let obj = {
            mainIndex: header[index].label,
            unit: header[index].unit
          };
            data.forEach((ele, ind) => {
                obj[`type${ind}`] = ele[header[index].value];
            });
          enddata.push(obj);
        }
      });
      return [enddata, endheader];
    },
    
    // 列表内容数据格式化
    tableFormatter(prop, row) {
        //  || row[prop] == 0 
      if (row[prop] && row[prop] != 0) {
        if (prop === 'mainIndex') {
          if (row.unit) {
            return `${row[prop]}（${row.unit}）`;
          }
          return row[prop];
        }else if(row.mainIndex == '價錢(未補)' || row.mainIndex == '放售價'){
            return parseInt(row[prop] / 10000) +'萬元';
        }else if(row.mainIndex == '放租價'){
            return parseInt(row[prop]) +'元';
        }else if(row.mainIndex == '起租日(租盤)' && (row[prop] == '1970/01/01' || row[prop] == 'yyyy/MM/dd')){
            return '-';
        }else if(row.mainIndex == '樓盤介紹(中)' || row.mainIndex == '樓盤介紹(英)'){
            return row[prop].replace(/\n/g, "<br/>").replace('<<<link','<<&ltlink');
        }else{
            return row[prop];
        }
        // return row[prop];
      }
      return '-';
    },
    },
}
</script>

<style scoped lang="less">
    .tablecon{
        line-height:24px;
    }
    .tablebox {
        background-color: #ffffff;
        padding: 20px;
        padding-bottom:50px;
        border-radius: 20px;
        width:100%;
        box-sizing:border-box;
        /deep/.el-table__header-wrapper {
            border-radius: 10px;
        }
    }
    .red{
        color:#E50113;
    }
    .overflow{
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 3; //行数
        -webkit-box-orient: vertical;
        display: -webkit-box;

    }
    .blucopy{
        color:#0062FF;
        cursor:pointer;
    }
    .titblack{
        color:#171725;
    }
    .left-right-scorll {
        width: 100%;
        width: calc(100% - 160px);
        margin-top: 12px;
        height: 24px;
        text-align: center;
        position: fixed;
        bottom: 48px;
        span {
            margin: 0 48px;
            display: inline-block;
            position: relative;
            height: 30px;
            height: 30px;
            width: 52px;
            cursor: pointer;
            overflow: hidden;
            border-radius: 4px;
            &:hover {
                background-color: #ccc;
            }
        }
        .icon {
            font-size: 68px;
            position: absolute;
            left: -6px;
            top: -20px;
            z-index: 99;
        }
    }
.journalbox{
    text-align:left;
}
.title{
    color:#171725;
    font-size:24px;
    margin-bottom:20px;
}

</style>
